import {connect} from 'react-redux';
import {CustomiseSummary} from './CustomiseSummary';
import {findSection, updateSectionValue} from 'ducks/reportSections';
import {updatePreferences} from 'actionCreators/preferences';
import actionCreators from 'actionCreators';
import {uploadImageToSummaryGalleryList} from 'actionCreators/uploadPropertyImage';
import {updatePropertyPreferences} from 'api/propertyPreferences';
import {updateSelectedPropertyImage} from 'ducks/propertyDetail';
import {getFetchingFromState} from 'lib/PropertyUtils';
import {PROPERTY_AVM_FIELDS} from 'lib/Commons';

const mapStateToProps = (state) => {
  const {featureFlags: {rapidSearchEnabled}, propertyDetail: {propertyId}} = state;
  const reportType = state.reportType.value;
  const isAvmFetching = !!rapidSearchEnabled && getFetchingFromState({
    propertyId,
    state,
    updateFields: PROPERTY_AVM_FIELDS
  });
  return {
    isAvmFetching,
    userDetails: state.userDetails,
    propertyDetail: state.propertyDetail,
    section: findSection(state.reportSections, reportType, 'SUMMARY'),
    reportType: reportType,

    updatePropertyPreferences: (preferences) => {
      updatePropertyPreferences(state.propertyDetail.propertyId, preferences);
    },
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    sendEvent(section, title) {
      dispatch(actionCreators.sendEditTitleAnalyticsEvent(section, title));
    },
    updateValue: (data) => {
      dispatch(updateSectionValue(data));
    },
    updatePreferences: (preferences, reportType) => {
      dispatch(updatePreferences(preferences, reportType));
    },
    onImageChange: (index, image) => {
      dispatch(updateSelectedPropertyImage(index, image, true));
    },
    onUpload: (files, galleryIndex) => dispatch(uploadImageToSummaryGalleryList(files[0], galleryIndex)),
  };
};

const mergeProps = (stateProps, dispatchProps) => {
  return {
    ...stateProps,
    ...dispatchProps,
    updateSectionValue: (value, dataKeyPath) => {
      dispatchProps.updateValue({
        value,
        reportType: stateProps.reportType,
        key: 'SUMMARY',
        dataKeyPath: `sectionData.${dataKeyPath}`,
      });
      if (dataKeyPath === 'title') {
        dispatchProps.sendEvent(stateProps.section, value);
      }
    },
  };
};



export default connect(mapStateToProps, mapDispatchToProps, mergeProps)(CustomiseSummary);